import { Expose, Type } from 'class-transformer';
import { decorate } from 'ts-mixer';

export class LoginAttemptResource {
    @decorate(Expose({ name: 'remaining_count' }))
    remainingCount: number = 0;

    @decorate(Expose({ name: 'unlock_time' }))
    unlockTime: string = '';
}

export class CredentialResource {
    @decorate(Expose({ name: 'access_token' }))
    accessToken: string = '';
    @decorate(Expose({ name: 'refresh_token' }))
    refreshToken: string = '';
    @decorate(Expose({ name: 'token_type' }))
    tokenType: string = '';
}

export class MenuResource {
    @decorate(Expose({ name: 'id' }))
    id: string = '';
    @decorate(Expose({ name: 'name' }))
    name: string = '';
    @decorate(Expose({ name: 'prgm_name' }))
    programName: string = '';
    @decorate(Expose({ name: 'icon_name' }))
    iconName?: string = '';
    @decorate(Expose({ name: 'position' }))
    position: number = 0;
    @decorate(Expose({ name: 'children' }))
    @decorate(Type(() => MenuResource))
    children?: MenuResource[];
}

export class UserInterfaceResource {
    @decorate(Expose({ name: 'nickname' }))
    nickname: string = '';

    @decorate(Expose({ name: 'actions' }))
    actions: string[] = [];
    @decorate(Expose({ name: 'menus' }))
    @decorate(Type(() => MenuResource))
    menus: MenuResource[] = [];
}
